import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { CalendlyModalProps } from './interface';
import useDevice from '@mp/hooks/useDevice.web';
import { PhoneScreeningSchedulerForm } from './PhoneSchedulerForm.web';

export const CalendlyModal = ({ open, onClose }: CalendlyModalProps) => {
  const isDesktop = useDevice() === 'desktop';
  const queryClient = useQueryClient();

  const handleClose = () => {
    queryClient.invalidateQueries({ queryKey: ['GetProfessionalTodos'] });
    onClose();
  };

  return (
    <BottomSheetDialog
      isDesktop={isDesktop}
      sx={{ alignSelf: isDesktop ? 'center' : 'end' }}
      open={open}
      onClose={handleClose}
      title="Follow-up screening"
      fullWidth
      content={<PhoneScreeningSchedulerForm />}
    />
  );
};
